import React from 'react';
import {
  Card,
  CardBody,
  CardText,
  CardTitle,
} from 'reactstrap';
import styles from './Offer.styles.module.scss';
import stringTable from '../../config/stringTable';

const englishIsTheOnlyLanguageSupported = 'en';
const wordings = stringTable[englishIsTheOnlyLanguageSupported];

export default function OfferExpired({ offer }) {
  if (!offer.errorType) return null;
  return (
    <Card>
      <CardBody className={styles.card}>
        <CardTitle tag="h5">
          { wordings['Your Personal Offer has Expired'] }
        </CardTitle>
        <CardText>
          { wordings['Sorry, it looks like this offer has expired.'] }
        </CardText>
      </CardBody>
    </Card>
  );
}
